import {get, post, postJson, put, deleteApiJson} from '../axios'

const RESOURCE_BASE_PATH = '/member-multiple-point'

// 查询店铺多倍积分配置信息接口
export const getMultifoldConfig = p => get(`${RESOURCE_BASE_PATH}/rule`, p);

// 修改店铺多倍积分配置信息接口
export const editMultifoldConfig = p => postJson(`${RESOURCE_BASE_PATH}/rule`, p);

// 查询特殊场景购物积分发放规则列表接口
export const getSpecialConfig = p => get(`${RESOURCE_BASE_PATH}/special-scene/list`, p);

// 保存修改特殊场景购物积分发放规则列表接口
export const saveSpecialConfig = p => postJson(`${RESOURCE_BASE_PATH}/special-scene`, p);

// 删除修改特殊场景购物积分发放规则列表接口
export const delSpecialConfig = p => deleteApiJson(`${RESOURCE_BASE_PATH}/special-scene/${p}`);

// 分页查询多倍积分发放记录列表接口
export const getRecordList = p => get(`${RESOURCE_BASE_PATH}/send-record/page`, p);

// 同一个订单命中多个多倍积分活动按最高的积分倍数发放开启关闭
export const setMaxsendFlag = p => get(`${RESOURCE_BASE_PATH}/rule/max-send-flag`, p);

// 查询sku列表
export const getSkuList = p => get(`/ware/sku/page`, p);

export const getSkuLists = p => postJson(`/ware/sku/page`, p);